// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".7b3a35e44a81a452bcaf586402b7f172.js";
};